import { connect } from 'react-redux';
import { openQuickViewWithValues } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import ShoppableHotspots from '../views/ShoppableHotspots.view';

export const mapStateToProps = (state, ownProps) => {
  return {
    data: ownProps.data,
    brandName: ownProps.brandName || '',
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onQuickViewOpenClick: (payload) => dispatch(openQuickViewWithValues(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShoppableHotspots);
